import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { OperatorConsolePage } from "./operator-console/OperatorConsolePage";

// Blue Harbor Labs Control Center is an internal operator dashboard.
// The public marketing landing page lives on the Blue Harbor Labs website,
// not in this app. Any visitor hitting the root or an unknown path is
// redirected to the Console route, which itself shows the login screen
// for unauthenticated visitors.
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/admin/operator-console"
            element={<OperatorConsolePage />}
          />
          <Route
            path="/"
            element={<Navigate to="/admin/operator-console" replace />}
          />
          <Route
            path="*"
            element={<Navigate to="/admin/operator-console" replace />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
